import type { VoidFunctionComponent } from 'react';

type Props = {
  isSmallIcon?: boolean;
};

/* eslint-disable react/no-unknown-property */
const NugetIcon: VoidFunctionComponent<Props> = ({ isSmallIcon }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={isSmallIcon ? 12 : 16} height={isSmallIcon ? 12 : 16} fill="none" viewBox="0 0 80 80"><g clip-path="url(#a)"><path fill="#512BD4" d="M80 0H0v80h80V0Z" /><path fill="#fff" d="M14.259 51.111a2.015 2.015 0 0 1-1.443-.565c-.396-.387-.594-.846-.594-1.378 0-.541.198-1.005.594-1.392.396-.386.877-.58 1.443-.58.575 0 1.06.194 1.456.58.405.387.608.85.608 1.392 0 .532-.203.99-.608 1.378-.396.377-.881.565-1.456.565ZM36.871 50.792h-3.676L23.508 35.51a6.83 6.83 0 0 1-.608-1.204h-.085c.075.445.113 1.397.113 2.857v13.63h-3.253V30h3.918l9.361 14.92c.396.619.65 1.044.764 1.276h.056c-.094-.551-.141-1.484-.141-2.799V30h3.238v20.792ZM52.71 50.792H41.327V30h10.93v2.929h-7.565v5.887h6.972v2.914h-6.972v6.148h8.018v2.914ZM68.889 32.929h-5.826v17.863h-3.366V32.93h-5.812V30h15.004v2.929Z" /></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h80v80H0z" /></clipPath></defs></svg>
  );
};

export default NugetIcon;
